import { useSearchParams } from "react-router-dom";
import ParameterIndicator from "../dashboard/ParameterIndicator";
import ParameterForms from "./ParametersForms";
import ParametersGlobalEmailTemplates from "./ParametersGlobalEmailTemplates";
import ParametersEmailTemplates from "./ParametersEmailTemplates";
import ParametersFormsLibrary from "./ParametersFormsLibrary";

const ParametersPage = () => {
  const [searchParams] = useSearchParams();
  const params = searchParams.get("params");
  const callId = searchParams.get("callId");
  const projectTypeId = searchParams.get("projectTypeId");
  const preservedCallId = searchParams.get("preservedCallId");

  if (params === "1") {
    return <ParameterIndicator />;
  }

  if (params === "2") {
    if (callId || projectTypeId || preservedCallId) {
      return <ParameterForms />;
    }
    return <ParametersFormsLibrary />;
  }

  if (params === "3") {
    if (callId) {
      return <ParametersEmailTemplates />;
    }

    return (
      <div className="space-y-6">
        <div className="rounded-3xl border border-[#dfe9d8] bg-[linear-gradient(135deg,#ffffff_0%,#f4f8ef_100%)] p-5 md:p-6">
          <div className="space-y-2">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#edf6e7] px-3 py-1 text-xs font-medium text-[#486a2f]">
              Modèles d’email
            </div>
            <h1 className="text-2xl font-semibold tracking-tight text-[#18351b]">
              Paramétrage des emails
            </h1>
            <p className="max-w-3xl text-sm text-[#5f6d5c]">
              Personnalisez séparément les emails globaux de votre espace et ceux dédiés à vos appels à projets.
            </p>
          </div>
        </div>
        <ParametersGlobalEmailTemplates />
        <ParametersEmailTemplates hideHeader />
      </div>
    );
  }

  return <ParameterIndicator />;
};

export default ParametersPage;
